/**
 * Hook to interact with Meta Pixel (Facebook Pixel) tracking
 * Uses the fbq function that is injected globally by the Meta Pixel script
 */

declare global {
	interface Window {
		fbq?: (action: string, event: string, data?: Record<string, any>) => void
	}
}

export const useMetaPixel = () => {
	/**
	 * Track a Meta Pixel event
	 * @param eventName - The name of the event to track (e.g., 'CompleteRegistration', 'Purchase')
	 * @param data - Optional data to send with the event
	 */
	const trackEvent = (eventName: string, data?: Record<string, any>) => {
		if (typeof window !== 'undefined' && window.fbq) {
			window.fbq('track', eventName, data)
		}
	}

	return {
		trackEvent,
	}
}
